var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canViewVerticalNavMenuLink(_vm.item))?_c('li',{staticClass:"nav-item",class:{
        active: _vm.isActive,
        disabled: _vm.item.disabled,
    }},[_c('b-link',_vm._b({staticClass:"d-flex align-items-center cu-menu-padding"},'b-link',_vm.linkProps,false),[_c('span',[_c('feather-icon',{attrs:{"icon":_vm.item.icon || 'CircleIcon'}})],1),_c('span',{staticClass:"menu-title text-truncate"},[_vm._v(_vm._s(_vm.t(_vm.item.title)))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }